import Quill from 'quill';
import AnchorLink from '@/components/texteditor/advanced/blots/anchorEmbed';
import QuillEventBus, { QuillEvents } from '@/components/texteditor/event-bus';
import config from '@/components/texteditor/config/advanced';

class AnchorLinkModule {
  constructor(quill, options) {
    this.quill = quill;
    this.listen();
  }

  listen() {
    this.quill.on(Quill.events.SELECTION_CHANGE, (range) => {
      if (!range) {
        return;
      }
      const [link] = this.quill.getLeaf(range.index);

      if (!(link instanceof AnchorLink)) {
        return;
      }

      const domNode = link.domNode;
      const bounds = domNode.getBoundingClientRect();

      const dialogConfig = config.toolbar['ql-anchor-link'];

      const message = {
        uuid: this.quill.uuid,
        params: {
          dialogConfig,
          fields: {
            value: domNode.id,
            position: { x: bounds.x, y: bounds.top + bounds.height },
            creating: false,
            range,
            link,
          },
        },
      };

      // mágico, sin el timeout no se levanta el tooltip
      setTimeout(() => {
        QuillEventBus.$emit(QuillEvents.CREATE, message);
      });
    });
  }
}

export default AnchorLinkModule;
